import React, { useState } from "react";
import CustomButton from "../../components/commons/CustomBtn";

import ActiviteListe from "./components/ActiviteListe";
import Container from "../../components/Container/Container";

const Activite = () => {
  const [activeOnglet, setActiveOnglet] = useState("toutes");
  const [activeView, setActiveView] = useState("lots");
  const onlgetSetter = (type) => {
    setActiveOnglet(type);
  };
  return null;
  // <Container className="px-40">
  //   <div className="d-flex gap10">
  //     <CustomButton
  //       onClick={() => onlgetSetter("toutes")}
  //       label="Toutes"
  //       buttonClass={`${activeOnglet === "toutes"
  //           ? "bg-white radiusTop5 px-20 py-10 "
  //           : "bg-pink radiusTop5 px-20 py-10"
  //         } `}
  //       labelClass={`${activeOnglet === "toutes"
  //           ? "pink fs16 semibold text-capitalize"
  //           : "white fs16 semibold text-capitalize"
  //         }`}
  //     />
  //     <CustomButton
  //       onClick={() => onlgetSetter("today")}
  //       label="Aujourd'hui"
  //       buttonClass={`${activeOnglet === "today"
  //           ? "bg-white radiusTop5 px-20 py-10 pink"
  //           : "bg-pink radiusTop5 px-20 py-10 white"
  //         } `}
  //       labelClass=" fs16 semibold text-capitalize"
  //     />
  //     <CustomButton
  //       onClick={() => onlgetSetter("avenir")}
  //       label="A venir"
  //       buttonClass={`${activeOnglet === "avenir"
  //           ? "bg-white radiusTop5 px-20 py-10 pink"
  //           : "bg-pink radiusTop5 px-20 py-10 white"
  //         } `}
  //       labelClass=" fs16 semibold text-capitalize"
  //     />
  //     <CustomButton
  //       onClick={() => onlgetSetter("retard")}
  //       label="en retard"
  //       buttonClass={`${activeOnglet === "retard"
  //           ? "bg-white radiusTop5 px-20 py-10 pink"
  //           : "bg-pink radiusTop5 px-20 py-10 white"
  //         } `}
  //       labelClass=" fs16 semibold text-capitalize"
  //     />
  //   </div>
  //   <ActiviteListe activeView={activeView} setActiveView={setActiveView} />
  // </Container>
};

export default Activite;
